export default [
  { label: 'Natural Sciences (e.g. Pre-Med, Biology, Chemistry, Physics, Geology)', value: 'natural_science' },
  { label: 'Technology (e.g. Computer Science, Data Analytics, Digital Media)', value: 'technology' },
  { label: 'Engineering (e.g. Civil, Mechanical, Electrical, Geotechnical, Chemical)', value: 'engineering' },
  { label: 'Mathematics (e.g. Pure Mathematics, Statistics, Economics, Finance)', value: 'math' },
  { label: 'Social Sciences (e.g. Anthropology, Economics, Education, Politics, Psychology, Sociology)', value: 'social_science' },
  { label: 'Arts & Humanities (e.g. Language, Literature, Philosophy, History, Visual & Performing Arts)', value: 'arts' },
  { label: 'Other', value: 'other' },
];